import LabelTableCell from 'Components/LabelTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import AuthorityTableRow from 'Services/common/Features/Authority/Components/AuthorityTableRow/AuthorityTableRow'
import { isSuperuser } from 'Services/common/Features/User/userSlice'
import type { SchoolCalendar } from 'Services/SchoolManagement/Features/SchoolCalendar/types'
import useTypedSelector from 'Store'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import { Paper, styled, Table, TableBody, TableCell, TableContainer } from '@mui/material'
import { t } from 'ttag'

const StyledTableCell = styled(LabelTableCell)`
  width: 40%;
`

interface SchoolCalendarDetailsProps {
  schoolCalendar: SchoolCalendar
}

export default function SchoolCalendarDetails({
  schoolCalendar
}: Readonly<SchoolCalendarDetailsProps>) {
  const { user } = useTypedSelector(state => state.user)

  return (
    <TableContainer component={Paper}>
      <Table sx={{ td: { border: 'none' } }} aria-label={t`Details table`}>
        <TableBody>
          {isSuperuser(user) && <AuthorityTableRow pta={schoolCalendar.codespace_id} />}
          <StyledTableRow>
            <StyledTableCell>{t`Calendar identifier`}</StyledTableCell>
            <TableCell>{schoolCalendar.calendar_id}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Name`}</StyledTableCell>
            <TableCell>{schoolCalendar.name}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Year`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(schoolCalendar.year)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Created`}</StyledTableCell>
            <TableCell>{datetimeFormatter(schoolCalendar.created_timestamp)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Modified`}</StyledTableCell>
            <TableCell>{datetimeFormatter(schoolCalendar.modified_timestamp)}</TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
